<template>
  <button :disabled="disabled" :class="['button', get_classes]">
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    primary: Boolean,
    rounded: Boolean,
    gray: Boolean,
    green: Boolean,
    transparent: Boolean,
    inline: Boolean,
    light: Boolean,
    small: Boolean,
    medium: Boolean,
    big: Boolean,
    extra_big: Boolean,
    wide: Boolean,
    disabled: Boolean,
    error: Boolean,
    success: Boolean,
    mobile_full_width: Boolean,
    type: {
      type: String,
      default: "default",
    },
    state: {
      type: String,
      default: "none",
    },
  },
  computed: {
    get_classes() {
      return {
        "button--primary": this.primary,
        "button--rounded": this.rounded,
        "button--gray": this.gray,
        "button--green": this.green,
        "button--transparent": this.transparent,
        "button--inline": this.inline,
        "button--light": this.light,
        "button--small": this.small,
        "button--medium": this.medium,
        "button--big": this.big,
        "button--extra-big": this.extra_big,
        "button--wide": this.wide,
        "button--disabled": this.disabled || this.is_disabled,
        "button--error": this.error,
        "button--success": this.success || this.is_sent,
        "button--mobile-full-width": this.mobile_full_width,
      };
    },
    is_sending() {
      return this.state === "sending";
    },
    is_wait() {
      return this.state === "wait";
    },
    is_sent() {
      return this.state === "sent";
    },
    is_disabled() {
      return true && (this.is_sending || this.is_wait);
    },
  },
};
</script>

<style
  scoped
  src="@/assets/css/components/form/button.scss"
  lang="scss"
></style>
